import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { TreasuryAccount } from '../../models/treasury.account.model';
import { legendValid, legendValidInvalidRestart } from '../../utils/legend.data.util';
import { prefixLegend, suffixLegend } from '../../scripts/name.legend.script';

import AppLegend from './Legend';

export interface AppInputTreasuryAccountProps {
  component?: string,
  type?: string,
  solid: boolean,
  treasuryAccountsForCompany: TreasuryAccount[],
  treasuryAccount: {value: string, valid: boolean, object: any},
  setTreasuryAccount: Dispatch<SetStateAction<{value: string, valid: boolean, object: any}>>,
  setAccountingEntry?: Dispatch<SetStateAction<{value: string, valid: boolean, object: any}>>
};

const AppInputTreasuryAccount: React.FunctionComponent<AppInputTreasuryAccountProps> = ({component, type, solid, treasuryAccountsForCompany, treasuryAccount, setTreasuryAccount, setAccountingEntry}) => {
  const {lang} = StateLanguage()

  const handleChangeTreasuryAccount = (item: TreasuryAccount) => {
    setTreasuryAccount({value: item.id, valid: true, object: item})
    legendValid(`${prefixLegend(component)}legend-treasury-account-required${suffixLegend(type)}`)

    if (setAccountingEntry) {
      setAccountingEntry({value: '', valid: false, object: null})
      legendValidInvalidRestart(`${prefixLegend(component)}legend-accounting-entry-required`)
    }
  }

  return (
    <>
      { treasuryAccountsForCompany &&
        <>
          <Dropdown>
            <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
              <span className="selection">
                <span className="select2-selection select2-selection--single form-select">
                  <span className={solid ? "select2-selection__rendered" : ""} role="textbox">
                    {treasuryAccount.valid ? treasuryAccount.object.name : lang.labels.selectOption}
                  </span>
                </span>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
              <span className="select2-dropdown select2-dropdown--below">
                <span className="select2-results">
                  <ul className="select2-results__options" role="listbox">
                    <li className={`select2-results__option select2-results__option--selectable ${treasuryAccountsForCompany.length > 0 && "d-none"}`}>
                      <Dropdown.Item bsPrefix="select2-results__option__text">{lang.labels.selectOption}</Dropdown.Item>
                    </li>
                    { treasuryAccountsForCompany.map (( (item, index) => { return (
                      <li key={index} className={`select2-results__option select2-results__option--selectable ${item.id === treasuryAccount.value && "select2-results__option--selected"}`} role="option" aria-selected={item.id === treasuryAccount.value}>
                        <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeTreasuryAccount(item)}>{item.name}</Dropdown.Item>
                      </li>
                    )}))}
                  </ul>
                </span>
              </span>
            </Dropdown.Menu>
          </Dropdown>
          <AppLegend component={component} attribute={{check: treasuryAccount.valid, name: "treasury-account", index: type ? type : null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
        </>
      }
    </>
  )
}

export default AppInputTreasuryAccount;
